import { omit, prop, map, indexBy, compose, filter, pathEq, converge, flip, pathOr } from "ramda";

import { getRenamedAd } from "../utils/renameAd";

const getCategoriesFromRels = compose(
    map(prop('title')),
    indexBy(prop('article_type')),
    map(prop('content')),
    filter(pathEq('articletype', ['content', 'component'])),
    prop('rels')
  )

const AdditionalCategories = converge(map, [
  compose(flip(prop), getCategoriesFromRels),
  pathOr([], ['story', 'content', 'additional_types'])
])

const Category = (data) => {
  const ads = map(prop("content"), data.adv || {});

  const lower_banner_panel = getRenamedAd(
    "show_ad_panel",
    "lower_banner_panel",
    ads
  );

  return {
    ...data.story,
    content: {
      ...data.story.content,
      additionalCategories:  AdditionalCategories(data),
      ads: {
        ...omit(["show_ad_panel"], ads),
        lower_banner_panel,
      },
    },
  };
};

export { Category };
